import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import api from "../../../../store/api";
import { AppThunk } from "../../../../store/app";
import { apiUrls } from "./apiUrls";

interface InitialState {
  isLoading: boolean;
  chart_js: any;
}

const initialState = {
  isLoading: false,
  chart_js: null,
} as InitialState;

const chartSlice = createSlice({
  name: "chartjs",
  initialState,
  reducers: {
    start: (state) => {
      state.isLoading = true;
    },
    success: (state) => {
      state.isLoading = false;
    },
    failure: (state) => {
      state.isLoading = false;
    },
    setChart: (state, action: PayloadAction<any>) => {
      state.chart_js = action?.payload;
    },
  },
});

export const { start, success, failure, setChart } = chartSlice.actions;

/** For Listing:Start */
export const fetchList =
  (action?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(apiUrls.chartMap, action);
      return Promise.resolve(response.data);
    } catch (error: any) {
      dispatch(failure());
      return Promise.reject(error.data);
    }
  };



  export const fetchUserList =
  (action?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(apiUrls.getChartUsers, action);
      return Promise.resolve(response.data);
    } catch (error: any) {
      dispatch(failure());
      return Promise.reject(error.data);
    }
  };


  export const downloadFilterdExcel =
  (action?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(apiUrls.downloadExcel, action);
      return Promise.resolve(response.data);
    } catch (error: any) {
      dispatch(failure());
      return Promise.reject(error.data);
    }
  };

/** For Listing:End */

const chartjs = chartSlice.reducer;
export default chartjs;
